// extracted by mini-css-extract-plugin
export default {"container":"CreateCorporation_container__sWI1B"};